import { getLang } from '../../utils'
import { getTeams } from '../../api';

export default function () {
    var s, r = window.pageYOffset || document.documentElement.scrollTop,
        o = document.querySelector('.js-header'),
        i = document.querySelector('.js-nav-list-mobile-container'), a = 'scrolling-down',
        c = 'scrolling-up',
        u = document.querySelector('.js-nav-active-line'), l = 4;
    
    function d(r) {
        for (var o = document.querySelectorAll('.js-nav-sub-link-trigger[aria-expanded="true"]:not(.js-nav-mobile-trigger)'), e = 0; e < o.length; e++) (function (e) {
            var t = o[e];
            if (!r || !t.isEqualNode(r)) {
                var n = document.querySelector('#' + t.getAttribute('aria-controls'));
                n.removeAttribute('style'), t.setAttribute('aria-expanded', 'false'), n.setAttribute('aria-expanded', 'false')
            }
        }).call(this, e);
        i.setAttribute('style', '')
    }
    
    function m(e) {
        var t = e ? e.scrollTop : window.pageYOffset || document.documentElement.scrollTop;
        if (t !== r) {
            var n = o.offsetHeight;
            r < t && n < t ? (o.classList.add(a), o.classList.remove(c), document.documentElement.classList.add(a), document.documentElement.classList.remove(c)) : (o.classList.add(c), o.classList.remove(a), document.documentElement.classList.add(c), document.documentElement.classList.remove(a)), g() && d(), r = t <= 0 ? 0 : t
        }
    }
    
    function f(e, t) {
        if (!t || g() && !e.querySelector('.js-nav-sub-link-trigger').classList.contains('js-nav-sub-link-trigger-no-line')) {
            var n = parseInt(window.getComputedStyle(e, null).getPropertyValue('padding-left')),
                r = parseInt(window.getComputedStyle(e, null).getPropertyValue('padding-right')),
                o = e.offsetLeft + n, i = e.getBoundingClientRect().width - n - r;
            u.style.transform = 'skew(14deg) translateX(' + (o - l) + 'px)', u.style.width = i + 2 * l + 'px'
        }
    }
    
    function v(r, o, i) {
        var s;
        return function () {
            var e = this, t = arguments, n = i && !s;
            clearTimeout(s), s = setTimeout(function () {s = null, i || r.apply(e, t)}, o), n && r.apply(e, t)
        }
    }
    
    function g() {return window.matchMedia('(min-width: 768px)').matches};

    function addTeam() {
        var ele = document.getElementById('nav-team');
        var text = '';
        getTeams().then(res=>{
            if(res && res.length > 0) {
                res.forEach((item, index) => {
                    var string = '<a href="./teams.html?index='+index+'" class="team-item" style="background-image:url('+item.icon+')"></a>'
                    text += string;
                });
                ele.innerHTML = text;
            }
        })
        
    }
    
    return {
        init: function () {
            o && (function () {
                var t = document.querySelector('.js-search-form'),
                    n = document.querySelector('.js-search-input'),
                    r = document.querySelector('.js-search-text'),
                    o = document.querySelector('.js-search-icon'),
                    e = document.querySelector('.js-search-trigger');
                if (!e) return;
                e.addEventListener('click', function () {
                    var e = 'true' === t.getAttribute('aria-hidden');
                    t.setAttribute('aria-hidden', !e), e ? (r.textContent = 'Close search form', o.querySelector('.js-search-icon-use').setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#icon-close'), n.focus()) : (r.textContent = 'Open search form', o.querySelector('.js-search-icon-use').setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#icon-search'), n.blur()), d()
                })
            }(), function () {
                for (var t = document.querySelectorAll('.js-nav-sub-link-trigger'), e = 0; e < t.length; e++) (function (e) {
                    var r = t[e];
                    r.addEventListener('click', function (e) {
                        e.preventDefault(), d(r);
                        var t = document.querySelector('#' + r.getAttribute('aria-controls')),
                            n = 'false' === r.getAttribute('aria-expanded').toLowerCase();
                        r.classList.contains('js-nav-mobile-trigger') || (n ? t.style.maxHeight = t.scrollHeight + 'px' : t.removeAttribute('style')), r.setAttribute('aria-expanded', n + ''), t.setAttribute('aria-expanded', n + '')
                    })
                }).call(this, e)
            }(), function () {
                if (!matchMedia('(hover: none)').matches) for (var i = document.querySelectorAll('.js-nav-sub-hover'), e = 0; e < i.length; e++) (function (e) {
                    var t, n = i[e], r = n.querySelector('.js-nav-sub-link-trigger'),
                        o = n.classList.contains('js-nav-no-sub-hover');
                    n.addEventListener('mouseover', function (e) {
                        if (e.preventDefault(), f(n, !o), g()) {
                            if (t && clearTimeout(t), s && clearTimeout(s), o) return;
                            t = setTimeout(function () {
                                var e = r.getAttribute('aria-controls');
                                if (e) {
                                    var t = document.querySelector('#' + e);
                                    r.setAttribute('aria-expanded', 'true'), t.setAttribute('aria-expanded', 'true')
                                }
                            }, 200)
                        }
                    }), n.addEventListener('mouseout', function (e) {
                        if (e.preventDefault(), g()) {
                            if (t && clearTimeout(t), s = setTimeout(function () {u.setAttribute('style', '')}, 400), o) return;
                            t = setTimeout(function () {
                                var e = r.getAttribute('aria-controls');
                                if (e) {
                                    var t = document.querySelector('#' + e);
                                    r.setAttribute('aria-expanded', 'false'), t.setAttribute('aria-expanded', 'false')
                                }
                            }, 200)
                        }
                    })
                }).call(this, e)
            }(), function () {
                var e = !1, t = 'mobile-nav-open', n = document.documentElement.scrollTop;
                document.querySelector('.js-nav-mobile-trigger').addEventListener('click', function () {(e = !e) ? (n = document.documentElement.scrollTop, document.documentElement.classList.add(t), window.addEventListener('resize', r), i.scrollTop = 0) : (document.documentElement.classList.remove(t), window.scrollTo(0, n), window.removeEventListener('resize', r))});
                var r = v(function () {g() ? document.documentElement.classList.remove(t) : document.documentElement.classList.add(t)}, 200)
            }(), function () {
                0 < r && (o.classList.add(a), o.classList.remove(c));
                var e = v(function () {window.requestAnimationFrame(function () {m()})}, 50);
                window.addEventListener('touchmove', e), window.addEventListener('scroll', e);
                var t = document.querySelector('.js-tv-left-container');
                if (t) {
                    var n = v(function () {window.requestAnimationFrame(function () {m(t)})}, 50);
                    t.addEventListener('touchmove', n), t.addEventListener('scroll', n)
                }
            }(), setTimeout(function () {o.classList.remove('c-header--loading')}, 300));

            // addTeam();

        }
    }
}